export default "__VITE_ASSET__D1MQ7$31__"